import { AdminRole } from "@repo/api-dtos"
import { createFileRoute, useNavigate } from "@tanstack/react-router"
import * as React from "react"
import { PageHeader } from "@/components/layout"
import { Skeleton } from "@/components/ui/skeleton"
import { useAdminRolesContext } from "@/contexts/admin-roles-context"
import { ReferralConfigEditor } from "@/features/referral-config/ReferralConfigEditor"
import { useReferralConfig } from "@/queries/marketplace"

export const Route = createFileRoute("/configuration/referral")({
	component: ReferralConfigurationPage,
})

function ReferralConfigurationPage() {
	const navigate = useNavigate()
	const { hasAnyRole, hasRole } = useAdminRolesContext()
	const canRead = hasAnyRole([
		AdminRole.Superadmin,
		AdminRole.MarketplaceRead,
		AdminRole.MarketplaceCoupons,
		AdminRole.MarketplaceOrderSupport,
	])
	const canEdit = hasRole(AdminRole.Superadmin)
	const { configVersion, isLoading, error, refetch } = useReferralConfig({
		enabled: canRead,
	})

	React.useEffect(() => {
		if (!canRead) navigate({ to: "/unauthorized" })
	}, [canRead, navigate])
	if (!canRead) return null

	return (
		<div className="flex max-w-5xl flex-col gap-6 p-6">
			<PageHeader
				title="Referral program"
				description="The Give a referred friend gets at checkout, the Get the referrer earns, how many transactions the Give covers, and the weekly release slot. Each save is a new version, used by checkout within a minute."
			/>
			{error ? (
				<p className="rounded-lg bg-bad-soft px-3 py-2 text-bad">
					Failed to load the configuration: {error.message}
				</p>
			) : isLoading || !configVersion ? (
				<div className="flex flex-col gap-3">
					<Skeleton className="h-[58px] w-full" />
					<Skeleton className="h-[58px] w-full" />
					<Skeleton className="h-[58px] w-full" />
					<Skeleton className="h-[58px] w-full" />
				</div>
			) : (
				<ReferralConfigEditor
					active={configVersion}
					canEdit={canEdit}
					onReload={() => refetch()}
				/>
			)}
		</div>
	)
}
